import script from "./ParagraphText.vue?vue&type=script&lang=js"
export * from "./ParagraphText.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__